module.exports = __webpack_public_path__ + "static/media/Mockup_bahsegel--desktop.00319ca2.png";